<template>
      <div class="guest-wrapper">
        <div class="remove guest-header">
              <div v-if="ModifyReservationAdditionalGuestFormTitle" class="guest-label"> {{ ModifyReservationAdditionalGuestFormTitle  }} </div>
              <button class="icon-close" @click.prevent="$emit('remove')" :aria-label="tc('booking.close')"></button>
        </div>
        <div class="flex-grid-2-col gutter-md guest-block">
          <input
              type="hidden"
              :data-default-value="confirmationNumber"
              :value="confirmationNumber"
               data-val="true"
              :id="`additional-guest-confirmation-${index}`"
              :name="`additional-guest-confirmation-${index}`"
            />
          <div class="input">
            <input
              type="text"
              :data-default-value="guestFirstName"
              :id="`additional-guest-firstname-${index}`"
              :name="`additional-guest-firstname-${index}`"
              maxlength="255"
              data-val="true"
              data-rule-minlength="1"
              data-rule-maxlength="50"
              :data-msg-minlength="getValidationForField('minChars', '1')"
              :data-msg-maxlength="getValidationForField('maxChars', '50')"
              :data-val-no-special-chars="tc('validations.noSpecialChars')"
              data-field-type="SingleLineText"
            />
            <label :for="`additional-guest-firstname-${index}`" class="floating">
              {{ tc('formFields.firstName') }}
            </label>
            <span
              :data-valmsg-for="`additional-guest-firstname-${index}`"
              data-valmsg-replace="true"
              class="field-validation-valid"
            ></span>
          </div>
          <div class="input">
            <input
              type="text"
              class="req"
              :data-default-value="guestLastName"
              :id="`additional-guest-lastname-${index}`"
              :name="`additional-guest-lastname-${index}`"
              maxlength="255"
              data-val="true"
              data-rule-minlength="1"
              data-rule-maxlength="65"
              :data-msg-minlength="getValidationForField('minChars', '1')"
              :data-msg-maxlength="getValidationForField('maxChars', '65')"
              :data-val-no-special-chars="tc('validations.noSpecialChars')"
              :data-val-required="getValidationForField('required', 'lastName')"
              data-field-type="SingleLineText"
            />
            <label :for="`additional-guest-lastname-${index}`" class="req floating">
              {{ tc('formFields.lastName') }}
            </label>
            <span
              :data-valmsg-for="`additional-guest-lastname-${index}`"
              data-valmsg-replace="true"
              class="field-validation-valid"
            ></span>
          </div>
        </div>
       </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'additional-guests-input',
  props: {
    index: {
      type: Number
    },
    guest: {
        type: Object,
        default: function () {
          return {
          firstName: '',
          lastName: '',
          confirmationNumber: '',
          id:'',
        };
      }
    },
  },
  computed: {
    ...mapGetters('i18n', ['tc']),
    ...mapGetters('modifyReservation', ['storedModifyBookingPropData']),
    guestFirstName() {
      return this.guest.firstName
    },
    guestLastName() {
      return  this.guest.lastName
    },
    confirmationNumber() {
      return  this.guest.confirmationNumber
    },
    ModifyReservationAdditionalGuestFormTitle() {
      return this.storedModifyBookingPropData?.ModifyReservationAdditionalGuestFormTitle
      ? this.storedModifyBookingPropData.ModifyReservationAdditionalGuestFormTitle : ''
    },
  },
  methods: {
    getValidationForField(validation, field = '') {
        return this.tc(`validations.${validation}`).replace('{0}', this.tc(`formFields.${field}`))
    },
  }
}
</script>
